/** Por encima del panel del buscador (`zindex1000`) y de los bloques SEO de la página (10001). */
export const CAPA = "z-[10050] bg-white";
